import { connect } from "react-redux";

import KompressorBild from "./KompressorBild";

import { makeUndefinedCompressor } from "../model/Kompressor";

export default connect((state, own_props) => ({
	compressor: state.ablauf.compressors[own_props.match.params.compressorIndex] ||
		makeUndefinedCompressor(own_props.match.params.compressorIndex)
}))(KompressorBild);
